import { AuthStore, Environment } from '@uplift/store';
import { createContext } from 'react';

export const RootStoreContext = createContext<{
  authStore: AuthStore;
  environment: Environment;
} | null>(null);
